<template>
  <div class="callback-page">
    <div class="container">
      <div class="card text-center p-4 mt-5">
        <div class="card-body">
          <div v-if="checking">
            <h4>Confirming your payment...</h4>
            <p class="text-muted">
              Please wait a few seconds while we confirm your subscription.
            </p>
          </div>
          <div v-else-if="status === 'cancel'">
            <h4 class="text-warning">Payment cancelled</h4>
            <p class="text-muted">
              Your subscription was not activated. You can try again at any time.
            </p>
            <router-link to="/account/subscription" class="btn btn-primary">
              Back to subscription
            </router-link>
          </div>
          <div v-else>
            <h4 :class="active ? 'text-success' : 'text-muted'">
              {{ active ? 'Subscription active!' : 'Payment received' }}
            </h4>
            <p class="text-muted">
              {{
                active
                  ? 'Thank you — your account is now active.'
                  : 'We received your payment. Activation may take a few moments.'
              }}
            </p>
            <router-link to="/account/subscription" class="btn btn-primary">
              Go to my subscription
            </router-link>
            <router-link to="/" class="btn btn-outline-secondary ml-2">
              Dashboard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/utils/firestore-shim";
import UserAuth from "../../auth/index.js";

export default {
  name: "PaymentCallback",
  data() {
    return {
      status: "",
      provider: "",
      checking: true,
      active: false
    };
  },
  async mounted() {
    this.status = this.$route.query.status || "";
    this.provider = this.$route.query.provider || "";
    if (this.status === "cancel") {
      this.checking = false;
      return;
    }
    // L'activation réelle vient du webhook : on interroge l'abonnement
    // quelques fois pour refléter le statut dès que possible.
    await this.pollSubscription(6, 1500);
    this.checking = false;
  },
  methods: {
    async pollSubscription(times, delayMs) {
      for (let i = 0; i < times; i++) {
        try {
          const profile = await firebase.auth().fetchProfile();
          UserAuth.setProfile(profile);
          const sub = profile && profile.subscription;
          if (sub && (sub.status === "active" || sub.status === "trialing")) {
            this.active = true;
            return;
          }
        } catch (e) {
          // Session peut-être pas encore prête : on retente.
        }
        await new Promise(resolve => setTimeout(resolve, delayMs));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.callback-page {
  min-height: 100vh;
  background-color: #f3f6f9;
}
</style>
